import { RootState } from "../../../system/redux/store/community-finder-redux-store";

/** Selects the owning team from the Redux state. */
export const selectOwningTeam = (state: RootState) =>
	state?.areaInfo.OwningTeam;
